module.exports = __webpack_public_path__ + "static/media/torque-dark.f96eb781.svg";